import React from 'react'
import { StandardDialog } from './modals'
import Pouces from '../images/success_smile.jpg'
import PrimaryBtn from './elements/Buttons/PrimaryBtn'

/**
 * SUCCESS DIALOG COMPONENT
 * @param {{ open: boolean, title: string, description: string, close: () => void, display: boolean }} props 
 * @returns {JSX.Element}
 */
function SuccessDialog({ open, title = 'Félicitations', description, close, display = false }) {
  return (
    <StandardDialog open={open} onClose={close}>
      <div className="bg-white rounded-3xl flex flex-col justify-center items-center space-y-4">
        <img src={Pouces} alt='SARA SUCCESS ACTION' className='h-64 object-cover' />
        <h1 className="font-bold text-3xl text-gray-700">{title}</h1>
        <p className="text-sm font-medium text-gray-500">{description}</p>
        {display && <p className='w-[350px] mx-auto text-center text-sm'>
          <strong>Vos résultats seront disponibles dans quelques minutes dans votre onglet visibilité.</strong> <br />
          Laissez moi un peu de temps pour analyser tout cela.
        </p>}
        <PrimaryBtn onClick={close} label="Fermer" />
      </div>
    </StandardDialog>
  )
}

export default SuccessDialog